import { ApplicationController } from "../support/application-controller";

export default class extends ApplicationController {
    static targets = [
        "resource",
    ];

    openItem(e) {
        // To enable keyboard triggering using enter and space key only
        if (e.keyCode && !(e.keyCode === 13 || e.keyCode === 32)) return
        e.preventDefault();
        window.open(this.itemLink, "_self");
    }

    openItemInNewTab(e) {
        // To enable keyboard triggering using enter and space key only
        if (e.keyCode && !(e.keyCode === 13 || e.keyCode === 32)) return
        e.preventDefault();
        window.open(this.itemLink, "_blank");
    }

    get itemLink() {
        return this.data.get("link");
    }
}
